<template>
  <b-row>
    <LmButton
      class="col-auto"
      :value="$t('cancel')"
      buttonClass="btn-secondary"
      @click="$router.go(-1)"
    />
    <LmButton
      v-for="(item, index) in buttons"
      :key="index"
      class="col-auto"
      :buttonClass="item.buttonClass"
      :value="item.label"
      @click="$router.push(item.click.to)"
    />
  </b-row>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'

export default {
  components: {
    LmButton
  },
  props: {
    buttons: {
      type: Array
    }
  }
}
</script>
